module.exports = __webpack_public_path__ + "static/media/upload-button.02495737.svg";